import React, { useState, useContext} from 'react';
import Particules from "./shared/Particules";
import UserContext from './shared/UserContext.js';
import {getClt} from "./Sessions.jsx";
/*

    {
      page: 98,
      lib_page: "Test !",
      lib: "Vérifier la réponse à toute l'enquête - test !",
      reponse: "Totot"
    },

    */

export function Form1stPuzzle() {
    const reponseAttendue = '0';
    const titre_intro = "Étape n°2 : Trouvez la solution à l'énigme suivante :";
    const intro = "Un chasseur tire sur un arbre où se tiennent 12 oiseaux, en tuant un tier. Combien reste-t'il d'oiseaux dans l'arbre ?";
    const title = "Bonne réponse !";
    const texte = "Montrez cet écran à l'animateur pour recevoir le dossier d'enquête !";
    const [formState, setFormState] = useState(1);
    const [reponse, setReponse] = useState('');
    const [message, setMessage] = useState('');
    const [affichage, setAffichage] = useState('_'.repeat(2));
    const { session, setSession } = useContext(UserContext);
    const client = getClt();

    if (session.step !== 1) return;

    const handleWin1stPuzzle = () => {
        setSession({session, type: 'nextStep', client: client });
    };
    
    const Reset = () => {
        setFormState(1);
        setReponse('');
        setAffichage('');
        setMessage('');
    }

    const handleChange = (e) => {
        let text = e.target.value;  
        let nouvelAffichage = '';
        let message = '';
        for (let i = 0; i < reponseAttendue.length; i++) {
            if (text.length > i) {
                nouvelAffichage += text[i].toUpperCase();
            } else {
                nouvelAffichage += '_';
            }
        }
        
        if ( text.toString().length === reponseAttendue.length ) {
            if (text.toString().toUpperCase() === reponseAttendue) {
                message = 'Bravo ! Vous avez trouvé la bonne réponse.';
                setFormState(2);
            } else {
                message = text+' n\'est pas la bonne réponse. Réessayez !';
                nouvelAffichage = '_'.repeat(reponseAttendue.length);
                text = '';
            }
        }
        setReponse(text);
        setAffichage(nouvelAffichage);
        setMessage(message);
    };

    const renderForm = () => {

        if (formState === 2) {

            return (
                <div className="container text-center vert">
                    <div className="row boup confettis">
                        <h2>{title}</h2>
                        <h4>{texte}</h4>
                    </div>
                    <div className="row boup confettis">

                    </div>
                    <Particules/>
                    <button
                        onClick={() => handleWin1stPuzzle()}
                        className="btn btn-primary btn-lg btn-block"
                    >
                        <p>Montrez cet écran à l'animateur</p><p>puis cliquez ici</p>
                    </button>
                </div>
            );

        } else {
            return (
                <div className="container">
                    <form id="reponseForm" className="firstPuzzle">
                        <div className="boup confettis">
                            <h2>{titre_intro}</h2>
                            <h4>{intro}</h4>
                        </div>
                        <div className='message'>{message}</div>
                        <div className='reponse'>{affichage}</div>
                        <div className='input'>
                            <input
                                type="text"
                                value={reponse}
                                onChange={handleChange}
                                maxLength={reponseAttendue.length}
                                autoCapitalize="characters"
                                placeholder='Entrez votre réponse'
                            />
                        </div>
                    </form>
                </div>
            );
        }   
    }
    return renderForm();
};
export default Form1stPuzzle;